import React, { useState, useEffect } from 'react'
import { Box, Typography, Button, IconButton, Tooltip, TextField, MenuItem, CircularProgress, Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DataTable from "../components/DataTable";
import { webEndPoint } from '../constants/globalConstants';
import { makeRequest } from "../services/api";
import SnackbarAlert from "../components/SnackbarAlert";
export default function Products() {
    const [loading, setLoading] = useState(false);
    const [dataSource, setDataSource] = useState([]);
    const [productCategory, setProductCategory] = useState([]);
    const [open, setOpen] = useState(false);
    const [category, setCategory] = useState("");
    const [productName, setProductName] = useState("");
    const [weight, setWeight] = useState("");
    const [making, setMaking] = useState("");
    const [description, setDescription] = useState("");
    const [images, setImages] = useState([]);
    const [previews, setPreviews] = useState([]);
    const [snackbar, setSnackbar] = useState(false);
    const [message, setMessage] = useState("");
    const [editState, setEditState] = useState(null);
    const [openImageModal, setOpenImageModal] = useState(false);
    const [imageList, setImageList] = useState([]);
    useEffect(() => {
        fetchProductData();
    }, []);
    const fetchProductData = async () => {
        setLoading(true);
        try {
            let url = webEndPoint + "products";
            const response = await makeRequest("get", url);
            if (response) {
                setDataSource(response?.data);
                setLoading(false);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
        setLoading(true);
        try {
            let url = webEndPoint + "productcategory";
            const response = await makeRequest("get", url);
            if (response) {
                setProductCategory(response?.data);
                setLoading(false);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    const openAdd = () => {
        setEditState(null);
        setCategory("");
        setProductName("");
        setWeight("");
        setMaking("");
        setDescription("");
        setImages([]);
        setPreviews([])
        setOpen(true);
    };
    const openEdit = (data) => {
        setEditState(data);
        setCategory(data?.product_category_id);
        setProductName(data?.product_name);
        setWeight(data?.weight);
        setMaking(data?.making_charges_percentage);
        setDescription(data?.product_description);
        const existingImages = data?.product_images ? JSON.parse(data.product_images) : [];
        setImages(existingImages);
        setPreviews(existingImages);
        setOpen(true);
    };
    const handleImageUpload = async (e) => {
        const files = e.target.files;
        if (files.length > 0) {
            setLoading(true);
            let previewList = [];
            let uploadedImages = [];
            try {
                for (let i = 0; i < files.length; i++) {
                    const file = files[i];
                    const reader = new FileReader();
                    reader.onloadend = () => {
                        previewList.push(reader.result);
                        setPreviews([...previewList]);
                    };
                    reader.readAsDataURL(file);
                    const formData = new FormData();
                    formData.append('file', file);
                    const response = await fetch(webEndPoint + 'upload', {
                        method: 'POST',
                        body: formData,
                    });
                    const data = await response.text();
                    uploadedImages.push(data);
                }
                setImages(uploadedImages);
                setLoading(false);
                setMessage("Images uploaded successfully");
                setSnackbar(true);
            } catch (error) {
                console.error(error);
                setMessage('Error during file upload');
                setSnackbar(true);
                setLoading(false);
            }
        }
    };
    const handleSave = async () => {
        if (!productName || !weight || !making || !description) {
            setMessage("All Fileds are Required");
            setSnackbar(true);
            return;
        }
        setLoading(true);
        try {
            if (editState) {
                const categoryEditData = {
                    product_category_id: category,
                    product_name: productName,
                    weight: weight,
                    making_charges_percentage: making,
                    product_description: description,
                    product_images: images,
                    rating: 5
                };
                try {
                    let url = webEndPoint + "products/" + editState.rfId;
                    const response = await makeRequest("put", url, categoryEditData);
                    if (response) {
                        setLoading(false);
                        setMessage("App Product Updated Successfully");
                    }
                } catch (err) {
                    console.error(err);
                } finally {
                    setLoading(false);
                }
            } else {
                const categoryAddData = {
                    product_category_id: category,
                    product_name: productName,
                    weight: weight,
                    making_charges_percentage: making,
                    product_description: description,
                    product_images: images,
                    rating: 5
                };
                try {
                    let url = webEndPoint + "products";
                    const response = await makeRequest("post", url, categoryAddData);
                    if (response) {
                        setLoading(false);
                        setMessage("App Product Added Successfully");
                    }
                } catch (err) {
                    console.error(err);
                } finally {
                    setLoading(false);
                }
            }
            setDataSource([]);
            fetchProductData();
            setImages([]);
            setPreviews([]);
            setSnackbar(true);
            setOpen(false);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    const ViewImages = async (data) => {
        await setImageList([data]);
        setOpenImageModal(true)
    }
    const columns = ["S.No", "Category", "App Product Name", "Weight", "Making %", "Rating", "Images", "Action"];
    const rows = dataSource?.map((p, i) => {
        return [i + 1, p.category_name, p.product_name, p.weight, p.making_charges_percentage, p.rating,
        <Button variant="outlined" size="small" onClick={() => ViewImages(p)}>View Images</Button>,
        <Box>
            <Tooltip title="Edit">
                <IconButton onClick={() => openEdit(p)} color="primary">
                    <EditIcon />
                </IconButton>
            </Tooltip>
        </Box>
        ];
    });
    return (
        <Box sx={{ position: "relative" }}>
            {loading && (
                <Box sx={{ position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh", backgroundColor: "rgba(255,255,255,0.6)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 9999, }}>
                    <CircularProgress />
                </Box>
            )}
            <Typography variant="h5" sx={{ mb: 3, fontWeight: 500 }}>App Products</Typography>
            <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
                <Button variant="contained" startIcon={<AddIcon />} onClick={openAdd}>Add App Product</Button>
            </Box>
            <DataTable columns={columns} rows={rows} loading={false} />
            {open && (
                <Box component="div" sx={{ position: "fixed", top: 0, left: 0, width: "100%", height: "100%", bgcolor: "rgba(0,0,0,0.5)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1200 }}>
                    <Box sx={{ bgcolor: "#fff", p: 3, borderRadius: 2, width: 1000 }}>
                        <Typography variant="h6" sx={{ mb: 2 }}>{editState !== null ? "Edit App Product" : "Add App Product"}</Typography>
                        <TextField select label="Select Product Category" value={category} onChange={(e) => setCategory(e.target.value)} sx={{ mb: 2 }} fullWidth>
                            {productCategory.map((cat) => (
                                <MenuItem key={cat.rfId} value={cat.rfId}>{cat.category_name}</MenuItem>
                            ))}
                        </TextField>
                        <TextField label="App Product Name" fullWidth value={productName} onChange={(e) => setProductName(e.target.value)} sx={{ mb: 2 }} />
                        <TextField label="Weight (grams)" type="number" fullWidth value={weight} onChange={(e) => setWeight(e.target.value)} sx={{ mb: 2 }} />
                        <TextField label="Making Charges (%)" type="number" fullWidth value={making} onChange={(e) => setMaking(e.target.value)} sx={{ mb: 2 }} />
                        <TextField label="Product Description" multiline rows={8} fullWidth value={description} onChange={(e) => setDescription(e.target.value)} sx={{ mb: 2 }} />
                        <Button variant="outlined" component="label"> Upload Images <input hidden type="file" accept="image/*" multiple onChange={handleImageUpload} sx={{ mb: 2 }} /></Button>
                        <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', mt: 2 }}>
                            {previews.map((src, index) => (
                                <img key={index} src={src} alt="preview" width={100} height={100} style={{ objectFit: 'cover', borderRadius: '8px' }} />
                            ))}
                        </Box>
                        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
                            <Button onClick={() => setOpen(false)}>Cancel</Button>
                            <Button variant="contained" onClick={handleSave}>Save</Button>
                        </Box>
                    </Box>
                </Box>
            )}
            <Dialog open={openImageModal} onClose={() => setOpenImageModal(false)} maxWidth="sm" fullWidth>
                <DialogTitle>Product Images</DialogTitle>
                <DialogContent>
                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}>
                        {imageList?.length > 0 ? (
                            imageList.map((item, index) => {
                                const images = item.product_images ? JSON.parse(item.product_images) : [];
                                return (
                                    <div key={index}>
                                        {images.length > 0 ? (
                                            images.map((img, imgIndex) => (
                                                <img key={`${index}-${imgIndex}`} src={img} alt="" width="300" height="300" objectFit="contain"
                                                    style={{ borderRadius: 8, border: "1px solid #000", marginRight: "10px" }} />
                                            ))
                                        ) : (
                                            <p>No Images Found</p>
                                        )}
                                    </div>
                                );
                            })
                        ) : (
                            <p>No Data</p>
                        )}

                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenImageModal(false)}>Close</Button>
                </DialogActions>
            </Dialog>
            <SnackbarAlert open={snackbar} setOpen={setSnackbar} message={message} />
        </Box>
    );
}